"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nextId = nextId;
function createError(message) {
    const err = new Error(message);
    err.source = 'ulid';
    return err;
}
const ENCODING = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
const ENCODING_LEN = ENCODING.length;
const TIME_MAX = Math.pow(2, 48) - 1;
const TIME_LEN = 10;
const RANDOM_LEN = 16;
function replaceCharAt(str, index, char) {
    if (index > str.length - 1) {
        return str;
    }
    return str.substr(0, index) + char + str.substr(index + 1);
}
function incrementBase32(str) {
    let done = undefined;
    let index = str.length;
    let char;
    let charIndex;
    const maxCharIndex = ENCODING_LEN - 1;
    while (!done && index-- >= 0) {
        char = str[index];
        charIndex = ENCODING.indexOf(char);
        if (charIndex === -1) {
            throw createError('incorrectly encoded string');
        }
        if (charIndex === maxCharIndex) {
            str = replaceCharAt(str, index, ENCODING[0]);
            continue;
        }
        done = replaceCharAt(str, index, ENCODING[charIndex + 1]);
    }
    if (typeof done === 'string') {
        return done;
    }
    throw createError('cannot increment this string');
}
function randomChar(prng) {
    let rand = Math.floor(prng() * ENCODING_LEN);
    if (rand === ENCODING_LEN) {
        rand = ENCODING_LEN - 1;
    }
    return ENCODING.charAt(rand);
}
function encodeTime(now, len) {
    if (isNaN(now)) {
        throw new Error(now + ' must be a number');
    }
    if (now > TIME_MAX) {
        throw createError('cannot encode time greater than ' + TIME_MAX);
    }
    if (now < 0) {
        throw createError('time must be positive');
    }
    if (Number.isInteger(now) === false) {
        throw createError('time must be an integer');
    }
    let mod;
    let str = '';
    for (; len > 0; len--) {
        mod = now % ENCODING_LEN;
        str = ENCODING.charAt(mod) + str;
        now = (now - mod) / ENCODING_LEN;
    }
    return str;
}
function encodeRandom(len, prng) {
    let str = '';
    for (; len > 0; len--) {
        str = randomChar(prng) + str;
    }
    return str;
}
function detectPrng() {
    return () => {
        const buffer = new Uint8Array(1);
        crypto.getRandomValues(buffer);
        return buffer[0] / 0xff;
    };
}
function monotonicFactory() {
    let lastTime = 0;
    let lastRandom;
    return function ulid(seedTime) {
        if (!seedTime || isNaN(seedTime)) {
            seedTime = Date.now();
        }
        if (seedTime <= lastTime) {
            const incrementedRandom = (lastRandom = incrementBase32(lastRandom));
            return encodeTime(lastTime, TIME_LEN) + incrementedRandom;
        }
        lastTime = seedTime;
        const newRandom = (lastRandom = encodeRandom(RANDOM_LEN, detectPrng()));
        return encodeTime(seedTime, TIME_LEN) + newRandom;
    };
}
const ulid = monotonicFactory();
function nextId() {
    return ulid();
}
//# sourceMappingURL=id.js.map